<!-- ProductListBody.vue -->
<template>
	<div class="ui-product-body">
		<div class="list">
			<div class="ui-image-wrapper">
				<img src="../../../assets/image/change-icon/default_image_02@2x.png" class="product-img" v-if='isPhotoEmpty(item)'>
				<img class="product-img" v-bind:src="getPhotoUrl(item)" v-if='!isPhotoEmpty(item)' data-src='../../../assets/image/change-icon/default_image_02@2x.png' >
				<span v-if="item.good_stock == 0">已售罄</span>
				<span v-if="item.good_stock > 0 && item.good_stock <= 2">仅剩{{ item.good_stock }}件</span>
			</div>
			<div class="flex-right">
				<div class="product-header">
	        <img class="promos-icon" v-if="(item.promos && item.promos.length > 0) || item.flashsale ||  item.discount" src="../../../assets/image/change-icon/c0_sale@2x.png" />
					<h3 class="title clear-bottom" style="-webkit-box-orient:vertical">{{ item.goods_name }}</h3>
				</div>
				<span class="sub-title" style="-webkit-box-orient:vertical">{{ item.goods_attr_str }}</span>
				<div class="price">
					<span>￥{{ item.rank_price }}</span>
					<span>￥{{ utils.currencyPrice(item.market_price)}}</span>
				</div>
				<div class="sendway">
					<span v-if="item.self_employed" class="self-support">自营</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations } from 'vuex';
import { cartAdd } from '../../../api/cart';

export default{
	data(){
		return{
		}
	},
	props: ['item', 'productId', 'requestparams'],

	computed: {
		...mapState({
			isOnline: state => state.auth.isOnline
		}),
	},
	methods: {
		isPhotoEmpty(item) {			
			let url = this.getPhotoUrl(item)
			return url && url.length ? false : true
		},
		getPhotoUrl(item) {
			let goods_thumb = item.goods_thumb
			if (goods_thumb) {
					return goods_thumb
			}
			return null
		},
		/*
		 * cartAdd: 加入购物车
		 * @param： product： 商品id
		*/
		_cartAdd(product) {
			if (this.isOnline) {
				cartAdd(product, '', 1).then(res => {
					if (res) {
						this.$parent.$emit('get-cart-quantity');
						Toast({message: '加入成功', position: 'middle', duration: 5000});
					}
				}, (error) => {
					Toast('请求异常:'+error.errorMsg);
				});
			} else {
				this.$router.push({'name': 'signin'});
			}
		},
	}
}
</script>

<style lang='scss'>
.ui-product-body {
	border-bottom: 1px solid rgba(232,234,237,1);
	.list {
		display: flex;
		width: auto;
		align-items: center;
		justify-content: space-between;
		margin: 11px 10px;
		position: relative;
		div.ui-image-wrapper {
			width: 110px;
			height: 110px;
			position: relative;

			display: flex;
		    justify-content: center;
		    align-content: center;
		    align-items: center;
			flex-basis: 110px;
			flex-shrink: 0;

			background-position:center center!important;
		    background: url("../../../assets/image/change-icon/default_image_02@2x.png");
		    background-size:100px 100px;
		    background-repeat:no-repeat;
		    -webkit-background-size: cover;
		    -moz-background-size: cover;
		    -o-background-size: cover;
		    background-size: cover;

			img.product-img{
				width: 110px;
				height: 110px;
				flex-basis: 110px;
				flex-shrink: 0;
			}
			img.product-img[lazy=loading] {
				width: 30px;
				height: 30px;
			}
			img.product-im[lazy=error] {
				width: 30px;
				height: 30px;
			}
			img.product-img[lazy=loaded] {
				width: 110px;
				height: 110px;
				flex-basis: 110px;
				flex-shrink: 0;
				background:rgba(255,255,255,1);
			}

			span {
				position: absolute;
				height:20px;
				background:rgba(243,244,245,1);
				line-height: 20px;
				text-align: center;
				font-size:14px;
				color:$primaryColor;
				width: 110px;
				bottom: 0px;
				left: 0px;
			}
		}

		span.promos {
			position: absolute;
			background: url('../../../assets/image/change-icon/label@2x.png') no-repeat;
			width: 36px;
			height: 19px;
			color: #FFFFFF;
			font-size: 10px;
			top: 0px;
			left: 0px;
			background-size: cover;
			font-weight: 100;
			line-height: 19px;
			text-align: left;
			padding-left: 5px;
		}
		.flex-right {
			padding-left: 14px;
			width: 100%;
			.title {
				color: #4E545D;
				font-size: 16px;
				font-weight: normal;

				display:-moz-box;
			  display:-webkit-box;
			    display:box;

				-webkit-line-clamp: 2;
				-moz-line-clamp: 2;

				-moz-box-orient:vertical;
				-webkit-box-orient:vertical;
				box-orient:vertical;

				overflow: hidden;
				margin-bottom: 8px;
				&.clear-bottom {
					margin-bottom: 0px;
				}
			}

			.product-header {
				display: flex;
	            align-items: center;
			}
			.promos-icon {
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }
			.sub-title {
				color: #55595F;
				font-size: 12px;

				display:-moz-box;
			  display:-webkit-box;
			  display:box;

				-webkit-line-clamp: 1;
				-moz-line-clamp: 1;

				-moz-box-orient:vertical;
				-webkit-box-orient:vertical;
				box-orient:vertical;

				overflow: hidden;
				margin-bottom: 8px;
			}
			.price {
				margin-bottom: 8px;
				span {
					&:first-child {
						color: $primaryColor;
						font-size: 16px;
					}
					&:last-child {
						color: #A4AAB3;
						font-size: 12px;
						text-decoration: line-through;
					}
				}
			}
			.sendway {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 12px;
				font-weight: 'Regular';
				span{
					color: #7C7F88;
					&.self-support {
						font-size: 10px;
						color: $primaryColor;
						border: 1px solid $primaryColor;
						border-radius: 2px;
						width: 32px;
					    height: 16px;
					    line-height: 16px;
					    text-align: center;
					}
				}
				img {
					width: 22px;
					height: 20px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/page/product-detail/child/CombinationPromotionBody.vue